import { Skeleton } from '@ibsys/kit';
import { type FC, useState } from 'react';
import { type MessageAttachmentResponse, useAttachmentUrl } from '@/entities/conversations';
import { AttachmentLightbox } from './AttachmentLightbox';
import { UnavailableAttachment } from './UnavailableAttachment';

type Props = {
  /** Вложение-изображение */
  attachment: MessageAttachmentResponse;
  /** Имя вложения */
  name: string;
};

/** Изображение во вложениях сообщения: превью до 360×270, нажатием — увеличенное поверх страницы. */
export const MessageImageAttachment: FC<Props> = ({ attachment, name }) => {
  const { url, isUnavailable } = useAttachmentUrl(attachment, true);
  const [isBroken, setIsBroken] = useState(false);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  if (isUnavailable || isBroken) return <UnavailableAttachment name={name} />;
  if (!url) return <Skeleton className="h-40 w-full max-w-90 rounded-lg" />;

  return (
    <div className="max-w-90">
      <img
        src={url}
        alt={name}
        role="button"
        tabIndex={-1}
        className="block h-auto max-h-67.5 w-auto max-w-full cursor-zoom-in rounded-lg object-contain"
        onClick={() => setIsLightboxOpen(true)}
        onError={() => setIsBroken(true)}
      />
      <AttachmentLightbox image={isLightboxOpen ? { src: url, name } : null} onClose={() => setIsLightboxOpen(false)} />
    </div>
  );
};
